<script lang="ts">
  import { onMount } from 'svelte'
  import LoadingIndicator from '@/components/LoadingIndicator.svelte'
  import { initClipboard } from '@/plugins/util'
  import { hasLocaToken } from '@/store'
  import { useRegisterSW } from 'virtual:pwa-register/svelte'
  import AppDriver from '@/components/appDriver/App.svelte'

  // PWA
  const { needRefresh } = useRegisterSW({
    onRegistered(swr) {
      console.log(`SW registered: ${swr}`)
    },
    onRegisterError(error) {
      console.log('SW registration error', error)
    }
  })

  if ($needRefresh === true) {
    window.location.reload()
  }

  // ================================================================================

  onMount(() => {
    if ($hasLocaToken) {
      localStorage.removeItem('LOCA_ACCESS_TOKEN')
    }

    initClipboard()
  })
</script>

<LoadingIndicator/>

<AppDriver/>
